// export const firebaseConfig = {
//     apiKey: 'AIzaSyCOEzyNKhOyAVWxZyCBXHhwjyYI5cooggM',
//     authDomain: 'hr-ray.firebaseapp.com',
//     databaseURL: 'https://hr-ray.firebaseio.com',
//     projectId: 'hr-ray',
//     storageBucket: 'hr-ray.appspot.com',
//     messagingSenderId: '626816807597'
// };


export const firebaseConfig =  {
    apiKey: 'AIzaSyC3wjEAVTRZ8_1qKrvy01FbHTjtkemdA40',
    authDomain: 'uneecops-chat-app.firebaseapp.com',
    databaseURL: 'https://uneecops-chat-app.firebaseio.com',
    projectId: 'uneecops-chat-app',
    storageBucket: 'uneecops-chat-app.appspot.com',
    messagingSenderId: '612583648893'
};



// WEBPACK FOOTER //
// ./src/environments/firebase.config.ts